import { render, staticRenderFns } from "./CustOrderAcceptPolicyPanel.vue?vue&type=template&id=0253b425&scoped=true"
import script from "./CustOrderAcceptPolicyPanel.vue?vue&type=script&lang=js"
export * from "./CustOrderAcceptPolicyPanel.vue?vue&type=script&lang=js"
import style0 from "./CustOrderAcceptPolicyPanel.vue?vue&type=style&index=0&id=0253b425&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0253b425",
  null
  
)

export default component.exports